import React, { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { Button } from "@/components/ui/button";

type Props = { email: string; onVerify: (code: string) => Promise<void>; onResend: () => Promise<unknown>; onBack: () => void };

export function OtpStep({ email, onVerify, onResend, onBack }: Props) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await onVerify(code);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-5 rise" data-testid="otp-step">
      <div className="flex items-start gap-3">
        <MailCheck className="mt-0.5 h-5 w-5 text-emerald-600" />
        <p className="text-sm text-muted-foreground">
          We sent a 6-digit code to <span className="font-semibold text-foreground" data-testid="otp-email">{email}</span>. It expires in 10 minutes.
        </p>
      </div>
      <InputOTP maxLength={6} value={code} onChange={setCode} autoFocus data-testid="otp-input" onComplete={() => undefined}>
        <InputOTPGroup>
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <InputOTPSlot key={i} index={i} className="h-12 w-11 text-lg" />
          ))}
        </InputOTPGroup>
      </InputOTP>
      <Button className="h-12 w-full rounded-sm bg-emerald-600 text-base hover:bg-emerald-700 text-white" disabled={code.length !== 6 || busy} onClick={submit} data-testid="otp-verify-button">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Verify & continue"}
      </Button>
      <div className="flex justify-between text-sm">
        <button className="text-muted-foreground hover:text-foreground" onClick={onBack} data-testid="otp-back-button">Change email</button>
        <button className="font-semibold text-emerald-700 hover:text-emerald-800" onClick={onResend} data-testid="otp-resend-button">Resend code</button>
      </div>
    </div>
  );
}
